import Message from './Components/Message';
import ItemList from './Components/ItemList';
import Header from './Components/Header';
import './App.css';

function App() {
  // Possible URL:s 
  // http://localhost:3000/web/latest?ui=web&locale=en-GB&vpc-code=KKPWF9
  // http://localhost:3000/web/latest#ui=web&locale=en-GB&vpc-code=KKPWF9
  // http://localhost:3000/dekis/web/latest/?app-id=walldeco#/?uiPlatform=web&locale=sv-SE
  return (
    <div className="App">
      <Header />
      <Message />
      <div className="divider"></div>
      <ItemList />
    </div>
  );
}

export default App;
